<script lang="ts">
	import { onDestroy } from "svelte";

	interface Props {
		threshold?: number;
		hasMore?: boolean;
		onLoadMore?: () => unknown;
	}

	let { threshold = 0, hasMore = false, onLoadMore }: Props = $props();

	let component: HTMLDivElement | undefined = $state();
	let intersectionObserver: IntersectionObserver | undefined;
	let loading = false;

	$effect(() => {
		if (component) {
			intersectionObserver?.disconnect();
			intersectionObserver = new IntersectionObserver(
				async entries => {
					if (entries[0].intersectionRatio <= 0) return;
					if (!hasMore || loading) return;
					loading = true;
					try {
						await onLoadMore?.();
					} finally {
						loading = false;
					}
				},
				{ threshold },
			);
			intersectionObserver.observe(component);
		}
	});

	onDestroy(() => {
		intersectionObserver?.disconnect();
	});
</script>

<div bind:this={component} class="w-0"></div>
